module.exports = __webpack_public_path__ + "media/images/category/feature/coj_f/logo-coj-en-e2e670db19a344aa94aa4e5751919897.png";